import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import "./ScenarioModal.css";

const EMPTY = "";

const NewScenarioModal = ({ onCreate, onClose }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [templates, setTemplates] = useState([]);
  const [templateId, setTemplateId] = useState(EMPTY); // EMPTY = empty scenario
  const [nameTouched, setNameTouched] = useState(false);

  // The standard scenarios are the ones that carry a templateKey (see DefaultScenarioSeeder)
  useEffect(() => {
    api
      .get("/scenario")
      .then((res) =>
        setTemplates((res.data || []).filter((s) => !!s.templateKey))
      )
      .catch((err) => console.error("Failed to load default scenarios:", err));
  }, []);

  const selected = templates.find((t) => t.id === templateId);

  const handleTemplateChange = (id) => {
    setTemplateId(id);
    // suggest a name until the user typed their own
    if (!nameTouched) {
      const t = templates.find((x) => x.id === id);
      setName(t ? `${t.name} (Copy)` : "");
    }
  };

  const canCreate = name.trim().length > 0;

  const handleCreate = () => {
    if (!canCreate) return;
    onCreate({
      name: name.trim(),
      description: description.trim(),
      templateId: templateId || null, // null = empty scenario
    });
    onClose();
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content modal-small">
        <h2 className="modal-title">Create New Scenario</h2>

        <label className="modal-label">
          Start from:
          <select
            className="modal-input"
            value={templateId}
            onChange={(e) => handleTemplateChange(e.target.value)}
          >
            <option value={EMPTY}>Empty scenario</option>
            {templates.map((t) => (
              <option key={t.id} value={t.id}>
                Copy of: {t.name}
              </option>
            ))}
          </select>
        </label>

        {selected && (
          <div className="modal-hint">
            Sections, their order and the panel settings are copied from "
            {selected.name}". You can change everything afterwards.
          </div>
        )}

        <label className="modal-label">
          Name:
          <input
            className="modal-input"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setNameTouched(true);
            }}
            placeholder="Scenario Name"
          />
        </label>

        <label className="modal-label">
          Description:
          <textarea
            className="modal-input"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Scenario description"
          />
        </label>

        <div className="modal-actions">
          <button className="btn-primary" disabled={!canCreate} onClick={handleCreate}>
            Create
          </button>

          <button className="btn-secondary2" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewScenarioModal;
